import { Route, Switch } from "react-router-dom";

// Import pages (JSX components) below.
import Home from "./pages/Home";
import CaseStudies from "./pages/CaseStudies";
import Licence from "./pages/Licence";
import InfrastructureLicence from "./pages/licences/InfrastructureLicence";
import InfrastructureLicenceV1 from "./pages/licences/InfrastructureLicenceV1";
import NotFound from "./pages/errors/404";

/**
 * @description Maps pages to their matching route/path.  
 * */
export default function Routes() {
    return (
        <Switch>
            <Route exact path="/">
                <Home />
            </Route>

            <Route exact path="/CaseStudies">
                <CaseStudies />
            </Route>

            <Route exact path="/licence">
                <Licence />
            </Route>

            <Route exact path="/licence/infrastructure">
                <InfrastructureLicence />
            </Route>

            <Route exact path="/licence/infrastructure/v1">
                <InfrastructureLicenceV1 />
            </Route>

            { /* Error 404 */}
            <Route path="" component={NotFound} />
        </Switch>    
    )
}
